import { useEffect } from "react";
import { useLazyQuery, useQuery } from "@apollo/client/react/hooks";
import {
  GET_WINDOW_CONFIG,
  GetWindowConfigOperationResponse,
} from "../../queries/window-config/window-config-queries";
import {
  GET_SESSION_CONFIG,
  GetSessionConfigOperationResponse,
} from "../../queries/session-config/session-config-queries";
import useTokenPageHandler from "../../../../../hooks/useTokenPageHandler";

export default function ConfigManager() {
  const { tokenExists } = useTokenPageHandler({ clientKey: "CONFIG_MANAGER" });

  const { client, refetch: refetchWindowConfig } =
    useQuery<GetWindowConfigOperationResponse>(GET_WINDOW_CONFIG, {
      fetchPolicy: "network-only",
      nextFetchPolicy: "cache-first",
      errorPolicy: "ignore",
    });

  const [fetchSessionConfig] = useLazyQuery<GetSessionConfigOperationResponse>(
    GET_SESSION_CONFIG,
    {
      fetchPolicy: "network-only",
      nextFetchPolicy: "cache-first",
      errorPolicy: "ignore",
    }
  );

  useEffect(() => {
    // This has to be refetched again because if a user logs out, the entire apollo store is cleared.
    // Since there's no option to clear everything except few identifiers, we can refetch
    // whenever the token status changes
    const unsubscribeClearStore = client.onClearStore(() =>
      refetchWindowConfig()
    );
    return () => unsubscribeClearStore();
  }, [client, refetchWindowConfig]);

  useEffect(() => {
    if (!tokenExists) {
      return;
    }

    fetchSessionConfig();
  }, [tokenExists, fetchSessionConfig]);

  return null;
}
